import React from "react";
import * as Styles from "../../../../../../common-deprecated/styles/v2/toyota/custom/services/SharedService";
import { BnbLabel } from "../../../utils/labels";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../redux/store";
import { INSURANCE_CALCULATOR } from "../../../../../../common-deprecated/constants";
import FinanceInsuranceCalculatorLink from "../../../utils/FinanceInsuranceCalculatorLink";
import useService from "../../../hooks/services/useService";
import { ServiceTypeEnum } from "../../../../../../common-deprecated/types/SettingsType";
import * as Preloader from "../../../../../../common-deprecated/styles/v2/toyota/custom/Preloader";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { clearInsuranceRate } from "../../../redux/actions/FinanceInsuranceActions";
import InsurancePrice from "../common/price/InsurancePrice";
import Popover from "../../../../../../common-deprecated/components/popover/aem/Popover";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const InsuranceService = (): JSX.Element | null => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const { info, fetching, isPersonalizedQuote } = useBnbSelector((state) => state.insuranceRate);
    const { disclaimer } = info;

    const data = useService(ServiceTypeEnum.Insurance);
    if (!data) return null;
    const { title, description, bannerLinkImage } = data;

    const disclaimerValue = {
        text: disclaimer ? (typeof disclaimer === "string" ? disclaimer : disclaimer.value || "") : "",
        table: !!disclaimer && typeof disclaimer === "object" && disclaimer.table ? disclaimer.table : [],
    };

    const popoverContent = disclaimerValue.text;

    return (
        <Styles.ServiceWrapper selected={isPersonalizedQuote}>
            {bannerLinkImage && (
                <Styles.Banner>
                    <Styles.Image src={`${bannerLinkImage}`} height={170} />
                </Styles.Banner>
            )}

            <Styles.Title>{title ? <span>{title}</span> : <BnbLabel label="insuranceTitle" />}</Styles.Title>

            <Styles.Description>
                {description ? (
                    <p dangerouslySetInnerHTML={{ __html: description }} />
                ) : (
                    <BnbLabel label="insuranceText" />
                )}
            </Styles.Description>

            {fetching ? (
                <Styles.Panel isLoading={fetching}>
                    <Preloader.default />
                </Styles.Panel>
            ) : (
                !!disclaimerValue.table.length && (
                    <Styles.Panel>
                        <Styles.Table>
                            {disclaimerValue.table.map((row) => (
                                <tr key={row.name}>
                                    <td>{row.name}</td>
                                    <td>
                                        <span dangerouslySetInnerHTML={{ __html: row.value }} />
                                    </td>
                                </tr>
                            ))}
                        </Styles.Table>
                    </Styles.Panel>
                )
            )}

            <Styles.PanelFooter>
                <Styles.PriceWrapper>
                    <InsurancePrice forceHideDisclaimer />
                    {!!popoverContent && <Popover showOnClick content={popoverContent as string} useHTML />}
                </Styles.PriceWrapper>
            </Styles.PanelFooter>

            <Styles.Actions>
                <FinanceInsuranceCalculatorLink
                    type={INSURANCE_CALCULATOR}
                    customButton={(props) => (
                        <Button.Checkbox
                            type="button"
                            selected={isPersonalizedQuote}
                            onClick={(event) => {
                                if (isPersonalizedQuote) {
                                    event.preventDefault();
                                    dispatch(clearInsuranceRate());
                                } else {
                                    props.onClick();
                                }
                            }}
                        >
                            <IconWrapper>
                                <Icon variant={isPersonalizedQuote ? "close" : "plus"} />
                            </IconWrapper>
                        </Button.Checkbox>
                    )}
                />
            </Styles.Actions>
        </Styles.ServiceWrapper>
    );
};

export default InsuranceService;
